jQuery(document).ready(function ($) {
    APP.init();
    APP.tabFooter();
    APP.otp_init();
    APP.popup();
    APP.tabs();

});
(function ($) {
    Drupal.behaviors.cardanoUser = {
        attach: function (context, settings) {
            APP.context = context;
            APP.select2();
            APP.accountForm();
            APP.joinCampaign();
            APP.datepicker();
            $('.hasDatepicker', context).datepicker("hide");
        }
    };
})(jQuery);
(function ($, Drupal) {
    Drupal.behaviors.preAjaxHook = {
        attach: function (context, settings) {
            if (google_recapcha_enable == 1) {
                $('#odc-account-form-submit', context)
                        .off('click.preAjaxHook')
                        .once('preAjaxHook')
                        .on('mousedown', function (e) {
                            e.preventDefault();
                            e.stopImmediatePropagation();

                            const $btn = $(this);

                            //const ajaxObj = Array.isArray(Drupal.ajax.instances)
                            //        ? Drupal.ajax.instances.find(
                            //                (a) => a && a.element && a.element.id === 'odc-account-form-submit'
                            //        )
                            //       : null;

                            const ajaxObj = (Array.isArray(Drupal.ajax.instances) && Drupal.ajax.instances.find(
                                    (a) => a && a.element && a.element.id === $btn.attr('id')
                            )) || Drupal.ajax[$btn.attr('id')];

                            const triggerAjax = function () {
                                ajaxObj.eventResponse($btn[0], $.Event('click'));
                            };

                            grecaptcha.ready(function () {
                                grecaptcha.execute($('input[name="account_site_key"]').val(), {action: "submit"})
                                        .then(function (token) {
                                            $('input[name="account_token_recaptcha"]').val(token);
                                            console.log("Token set:", token);
                                            setTimeout(triggerAjax, 2000);
                                        });
                            });
                        });

                $('#odc-additional-form-submit', context)
                        .off('click.preAjaxHook')
                        .once('preAjaxHook')
                        .on('mousedown', function (e) {
                            e.preventDefault();
                            e.stopImmediatePropagation();

                            const $btn = $(this);

                            //const ajaxObj = Array.isArray(Drupal.ajax.instances)
                            //        ? Drupal.ajax.instances.find(
                            //                (a) => a && a.element && a.element.id === 'odc-additional-form-submit'
                            //        )
                            //        : null;

                            const ajaxObj = (Array.isArray(Drupal.ajax.instances) && Drupal.ajax.instances.find(
                                    (a) => a && a.element && a.element.id === $btn.attr('id')
                            )) || Drupal.ajax[$btn.attr('id')];

                            const triggerAjax = function () {
                                ajaxObj.eventResponse($btn[0], $.Event('click'));
                            };
                            
                            grecaptcha.ready(function () {
                                    grecaptcha.execute($('input[name="additional_site_key"]').val(), {action: "submit"})
                                            .then(function (token) {
                                                $('input[name="additional_token_recaptcha"]').val(token);
                                                //console.log("Token set:", token);
                                                setTimeout(triggerAjax, 2000);
                                            });
                                });                                                                                                               
                        });
            }
        }
    };
})(jQuery, Drupal);

function shopPopupOtp() {
    $('.section__additional').removeClass('active');
    $('.section__verify_topup').addClass('active');
}

function xacNhanOtpTopup() {  
    if ($('#verifyTopup1').val() == '' || $('#verifyTopup2').val() == '' || $('#verifyTopup3').val() == '' || $('#verifyTopup4').val() == '' || $('#verifyTopup5').val() == '' || $('#verifyTopup6').val() == '') {
        $('.section__verify_topup .otp__message').html('<p>Vui lòng nhập mã bảo mật</p>');
        return false;
    }
    $("input[name='hdhOtpTopup']").val($('#verifyTopup1').val() + $('#verifyTopup2').val() + $('#verifyTopup3').val() + $('#verifyTopup4').val() + $('#verifyTopup5').val()+ $('#verifyTopup6').val());
    $('#odc-additional-form-submit').mousedown();
    $('.section__verify_topup').removeClass('active');
}